import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { UseMutationOptions } from "@tanstack/react-query";

import type { Addendum } from "@/core/types";

import { addendumKeys } from "../keyFactory";
import {
  type CreateNoteAddendumVariables,
  createNoteAddendum,
} from "../queryFunctions/createNoteAddendum";

export function useCreateNoteAddendum({
  onSuccess,
  ...options
}: UseMutationOptions<Addendum, unknown, CreateNoteAddendumVariables> = {}) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createNoteAddendum,
    ...options,
    onSuccess: async (data, variables, context) => {
      await queryClient.invalidateQueries({
        queryKey: addendumKeys.byNote(variables.noteId),
      });
      onSuccess?.(data, variables, context);
    },
  });
}
